import { Tab, Tabs } from "@clipboard-health/ui-components";
import { APP_V2_USER_EVENTS, logEvent } from "@src/appV2/lib/analytics";
import { openZendeskMessaging } from "@src/appV2/lib/ZendeskMessaging/openZendeskMessaging";

import { type ChatChannelCustomTypesFilter } from "../types";

interface ChatListFilterTabsProps {
  filterType: ChatChannelCustomTypesFilter;
  onFilterTypeChange: (newValue: ChatChannelCustomTypesFilter) => void;
}

export function ChatListFilterTabs({ filterType, onFilterTypeChange }: ChatListFilterTabsProps) {
  return (
    <Tabs
      variant="pill"
      value={filterType}
      onChange={(_, newValue: ChatChannelCustomTypesFilter) => {
        onFilterTypeChange(newValue);
      }}
    >
      <Tab variant="pill" label="All" value="all" />
      <Tab variant="pill" label="Flex" value="flex" />
      <Tab variant="pill" label="Jobs" value="placements" />
      <Tab
        variant="pill"
        label="Support"
        value="support"
        onClick={() => {
          logEvent(APP_V2_USER_EVENTS.ENTERED_SUPPORT_FLOW_VIA_CHAT);
          void openZendeskMessaging();
        }}
      />
    </Tabs>
  );
}
